import { render, staticRenderFns } from "./PayslipEditModal.vue?vue&type=template&id=2bbb9851"
import script from "./PayslipEditModal.vue?vue&type=script&lang=js"
export * from "./PayslipEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports